import api from '@/configurations/service';
import * as types from './mutation-types';

export const resetCfopParameterizationState = async (context) => {
  context.commit(types.RESET_CFOP_PARAMETERIZATION);
};

export const setSummaryCfopParameterizations = async (context, { search, pagination }) => {
  const body = { search, pagination };
  const { data } = await api().post('fiscal.get-cfop-parameterizations', body);

  context.commit(types.SET_PAGINATION_CFOP_PARAMETERIZATIONS, data.pagination);
  context.commit(types.SET_SUMMARY_CFOP_PARAMETERIZATIONS, data.data);
};

export const saveCfopParameterization = async (_, payload) => {
  const { id } = payload;

  if (!id) {
    await api().post('fiscal.register-cfop-parameterization', payload);
    return;
  }

  await api().post('fiscal.update-cfop-parameterization', payload);
};

export const setDetailedCfopParameterization = async (context, id) => {
  const { data } = await api().post('fiscal.get-cfop-parameterization-by-id', { id });

  context.commit(types.SET_DETAILED_CFOP_PARAMETERIZATION, data);
};

export const deleteCfopParameterizations = async (context, ids) => {
  await api().post('fiscal.delete-cfop-parameterization', { ids });
};
